export { default as ProductTable } from './ProductTable';
